const { createContext, useState, useEffect } = require("react");

export const AdminContext = createContext();

function AdminContextProvider({ children }) {
    const savedSubTema = Number(localStorage.getItem("@subTema"));
    const [subTema, setSubTema] = useState(savedSubTema || 0);
    const [subTemaId, setSubTemaId] = useState(2);

    useEffect(() => {
        const elementRoot = document.documentElement;

        const colorMap = {
            1: "#E5918B",
            2: "#5B97DB",
            3: "#FCC525",
            4: "#83B536",
        };

        const normalized = subTema > 0 ? ((subTema - 1) % 4) + 1 : 1;
        const color = colorMap[normalized] || colorMap[1];

        elementRoot.style.setProperty("--color-tema", color);
        localStorage.setItem("@subTema", String(subTema));
    }, [subTema]);

    return (
        <AdminContext.Provider
            value={{ subTema, setSubTema, subTemaId, setSubTemaId }}
        >
            {children}
        </AdminContext.Provider>
    );
}

export default AdminContextProvider;
